// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__CXKSq","title":"BackImages_title__1FXhn","images":"BackImages_images__3M6mz"};